<template>
  <section class="book-module-activity">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-9 col-lg-5">
          <h3 class="margin-top-xs-0 margin-bottom-xs-0">
            {{ ui.singleBookingHeadline }}
          </h3>
          <h3
            class="margin-top-xs-0 margin-bottom-xs-1 margin-bottom-md-2"
            v-text="activities.selected.activity_name"
          ></h3>
        </div>
        <div
          class="hidden-xs hidden-sm col-md-3 col-lg-offset-4 col-lg-3 text-align-right-md"
        >
          <p class="text-medium">
            <a
              :href="
                bookingUrl(activities.selected.activity_id)
              "
              class="link-arrow-right"
              >Se alla lediga tider</a
            >
          </p>
        </div>
      </div>
    </div>

    <img
      class="loading-spinner-nk"
      src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
      v-if="!availableTimes.length && !timesSettled"
    />

    <div
      class="container book-module-activity-empty"
      v-if="!availableTimes.length && timesSettled"
    >
      <p class="margin-bottom-xs-1">
        Just nu finns inga lediga tider att boka online de närmaste fyra
        veckorna. Ring oss gärna på
        <a href="tel:+4684117676" style="white-space: nowrap">08-411 76 76</a>.
      </p>
      <!-- On desktop the same link is already in the heading row -->
      <p class="text-medium hidden-md hidden-lg">
        <a
          :href="bookingUrl(activities.selected.activity_id)"
          class="link-arrow-right"
          >Se alla lediga tider</a
        >
      </p>
    </div>

    <div class="container-overflow-right hidden-xs hidden-sm" v-cloak>
      <slick ref="slick" @swipe="handleSwipe" :options="slickOptions">
        <div
          class="slick-book-time-feed-item text-center"
          v-for="(slot, index) in availableTimes"
          :class="{
            'slick-book-time-feed-item-active': slot == selectedSlot,
          }"
          v-if="index < 10"
        >
          <a href="#" @click.prevent="setSelectedSlot(slot)">
            <p class="book-time-date margin-bottom-xs-0">
              <span v-html="getSlotNiceDate(slot.date)"></span>,
              {{ slot.time }}
            </p>
            <p
              class="book-time-provider margin-bottom-xs-1 text-gray"
              v-html="formatProviderName(slot.terapeut_sign)"
            ></p>
            <p
              class="book-time-provider margin-bottom-xs-0 text-gray"
              v-if="slot.location_short_name"
            >{{ slot.location_short_name }}</p>
            <p class="book-time-provider margin-bottom-xs-0">Boka tid</p>
          </a>
        </div>
      </slick>
    </div>

    <div class="container hidden-md hidden-lg" v-cloak>
      <div class="row">
        <div class="col-xs-12">
          <div
            class="slick-book-time-feed-item text-center margin-bottom-xs-1"
            v-for="(slot, index) in availableTimes"
            :class="{
              'slick-book-time-feed-item-active': slot == selectedSlot,
            }"
            v-if="index <= ui.timeSlotsToShowMobile"
          >
            <a href="#" @click.prevent="setSelectedSlot(slot)">
              <p class="book-time-date margin-bottom-xs-0">
                <span v-html="getSlotNiceDate(slot.date)"></span>,
                {{ slot.time }}
              </p>
              <p>
                <span
                  class="text-gray"
                  v-html="formatProviderName(slot.terapeut_sign)"
                ></span>
              </p>
              <p
                class="book-time-provider margin-bottom-xs-0 text-gray"
                v-if="slot.location_short_name"
              >{{ slot.location_short_name }}</p>
              <p class="book-time-provider margin-bottom-xs-0">Boka tid</p>
            </a>
          </div>

          <p class="margin-top-xs-1">
            <a
              href="#"
              @click.prevent="
                ui.timeSlotsToShowMobile = ui.timeSlotsToShowMobile + 3
              "
              class="link-plus-right"
              v-if="ui.timeSlotsToShowMobile <= availableTimes.length"
              >Se fler tider</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="container" v-cloak>
      <div class="row" id="book-time-activity-form">
        <PatientForm />
      </div>
    </div>
    <BookingConfirmedModal />
    <BookingErrorModal />
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import MaskedInput from 'vue-masked-input';
import Slick from 'vue-slick';
import BookingConfirmedModal from './BookingConfirmedModal.vue';
import PatientForm from './PatientForm.vue';
import BookingErrorModal from './BookingErrorModal.vue';
import bookingUrl from '../helpers/bookingUrl';

export default {
  components: {
    MaskedInput,
    Slick,
    PatientForm,
    BookingConfirmedModal,
    BookingErrorModal,
  },
  computed: {
    ...mapState([
      'activityGroups',
      'activities',
      'providers',
      'selectedSlot',
      'dates',
      'ui',
      'booking',
      'patient',
      'availableTimes',
      'slickOptions',
    ]),
    ...mapGetters([
      'dateIsInThePast',
      'activityIsCampaign',
      'formatProviderName',
      'selectedSlotFormated',
      'formIsValid',
      'getSlotNiceDate',
    ]),
    /* No request for times in flight. getAvailableTimes clears loading.times before it clears the
    signal, and a request replaced by a newer one clears loading.times while the newer signal is set,
    so both have to be checked */
    timesIdle() {
      return !this.ui.loading.times && !this.ui.loading.signal;
    },
  },
  methods: {
    bookingUrl,
    ...mapActions([
      'setActivityGroup',
      'setActivity',
      'setupActiveDates',
      'setSelectedSlot',
      'setProvider',
      'getRealWeekday',
      'setModalState',
      'handleSwipe',
      'shouldDeselectTimeslot',
    ]),
  },
  data() {
    return {
      /* True once a request for times has finished, so an empty list means "no times" rather than "still loading" */
      timesSettled: false,
    };
  },
  created() {
    this.$store.dispatch('init', {
      vueInstance: this,
    });
  },

  watch: {
    timesIdle(isIdle) {
      if (isIdle) {
        this.timesSettled = true;
      }
    },
    /* Watch for changes to the availableTimes object. This is necessary to make the slick slider work as intended */
    availableTimes(newTimes) {
      if (!this.$refs.slick) {
        return;
      }

      let currIndex = this.$refs.slick.currentSlide();
      this.$refs.slick.destroy();
      this.$nextTick(() => {
        this.$refs.slick.create();
        this.$refs.slick.goTo(currIndex, true);
      });
    },
  },
};
</script>
